import { bufferTimeFn, checkTimeDuration } from './utils';

export const checkForStoreClosing = (storeDetails, buffertimepmdelivery, buffertimepmpickup) => {
  const bufferTiming = storeDetails && bufferTimeFn(storeDetails[0]?.service, buffertimepmdelivery, buffertimepmpickup);
  const storeSummary = storeDetails[0].summary;
  const calculateTimeDiff = bufferTiming && checkTimeDuration(storeSummary, bufferTiming);
  return calculateTimeDiff?.timingFlag;
};
